import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history, useModel } from '@umijs/max';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import {
  getRoutersInfo,
  getUserInfo,
  setRemoteMenu,
} from './services/session';
import { PageEnum } from './enums/pagesEnums';
import { HOME_PATH } from './utils/routeUtil';
import logo from '../public/icons/app.png';
import HeaderRight from './components/HeaderRight';
import MenuFooter from './components/MenuFooter';
import KeepAliveTabs from './components/KeepAliveTabs';
import { useEffect } from 'react';
import Footer from './components/Footer';

console.warn = () => {};
console.error = () => {};
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const response = await getUserInfo({
        skipErrorHandler: true,
      });
      if (!response.user.avatar) {
        response.user.avatar =
          'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png';
      }
      return {
        ...response.user,
        permissions: response.permissions,
        roles: response.roles,
      } as API.CurrentUser;
    } catch (error) {
      console.log(error);
      history.push(PageEnum.LOGIN);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  if (location.pathname !== PageEnum.LOGIN) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }: any) => {
  const { themeColor } = useModel('configModel');
  useEffect(() => {
    console.log('themeColor', themeColor);
  }, [themeColor]);
  console.log('initialState', initialState);

  return {
    logo,
    rightRender: () => <HeaderRight />,
    menuFooterRender: () => <MenuFooter />,
    footerRender: () => <Footer />,
    menu: {
      locale: false,
      // 每当 initialState?.currentUser?.userid 发生修改时重新执行 request
      params: {
        userId: initialState?.currentUser?.userId,
      },
      request: async () => {
        if (!initialState?.currentUser?.userId) {
          return [];
        }
        const routers = await getRoutersInfo();
        setRemoteMenu(routers);
        console.log('routers', routers);
        return routers;
      },
    },
    navTheme: themeColor,
    onPageChange: () => {
      const { location } = history;
      if (location.pathname === '/' || location.pathname === '') {
        history.replace(HOME_PATH);
        return;
      }
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== PageEnum.LOGIN) {
        history.push(PageEnum.LOGIN);
      }
    },
    onMenuHeaderClick: () => {
      history.push(HOME_PATH);
    },
    menuHeaderRender: undefined,
    breadcrumbRender: false,
    childrenRender: (children) => <KeepAliveTabs>{children}</KeepAliveTabs>,
    ...initialState?.settings,
  };
};

/**
 * @name request 配置
 * 所有请求相关配置统一在 requestErrorConfig.ts 中管理
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = errorConfig;
